import { initPopup } from '@theme/delivery-location-popup';
import {
  handleDeliveryRateUpdated,
  updateDisplays
} from '@theme/delivery-location-ui';
import {
  clearDeliveryEtaCache,
  getDeliveryEtaLocationKey,
  initDeliveryEta,
  refreshProductDeliveryEta,
  scheduleCartDeliveryEtaRefresh,
  scheduleProductDeliveryEtaRefresh
} from '@theme/delivery-location-eta';

let lastEtaLocationKey = '';

async function boot() {
  initPopup();
  updateDisplays();
  lastEtaLocationKey = getDeliveryEtaLocationKey();
  await initDeliveryEta(updateDisplays);
}

document.addEventListener('shopify:section:load', async function() {
  if (!document.querySelector('cart-items-component')) {
    clearDeliveryEtaCache();
  }
  updateDisplays();
  await initDeliveryEta(updateDisplays);
});

document.addEventListener('theme:delivery-rate-updated', function(e) {
  handleDeliveryRateUpdated(e && e.detail ? e.detail : {});
});

function onCartChange() {
  if (window.__themeShippingEstimateSilent) return;
  clearDeliveryEtaCache();
  if (document.querySelector('[data-delivery-estimate-scope="product"]')) {
    scheduleProductDeliveryEtaRefresh(updateDisplays);
  }
  scheduleCartDeliveryEtaRefresh(updateDisplays);
}

async function onLocationChange() {
  if (window.__themeShippingEstimateSilent) return;
  const nextKey = getDeliveryEtaLocationKey();
  if (lastEtaLocationKey && lastEtaLocationKey === nextKey) {
    updateDisplays();
    return;
  }
  lastEtaLocationKey = nextKey;
  clearDeliveryEtaCache();
  updateDisplays();
  await initDeliveryEta(updateDisplays);
}

document.addEventListener('cart:updated', onCartChange);
document.addEventListener('cart:update', onCartChange);
document.addEventListener('shopify:cart:update', onCartChange);
document.addEventListener('theme:delivery-location-updated', onLocationChange);

async function onVariantUpdate(event) {
  const detail = event && event.detail ? event.detail : {};
  const resource = detail.resource || detail.variant || null;
  if (!resource || !resource.id) return;
  const variantId = String(resource.id).trim();
  if (!/^\d+$/.test(variantId)) return;
  const card = document.querySelector('[data-delivery-estimate-scope="product"]');
  const currentId = card && card.getAttribute('data-estimate-variant-id');
  if (currentId === variantId) {
    if (card && card.getAttribute('data-delivery-eta-ready') === 'true') return;
    if (card && card.getAttribute('data-delivery-eta-pending') === 'true') return;
  }
  document.querySelectorAll('[data-delivery-estimate-scope="product"]').forEach(function(root) {
    root.setAttribute('data-estimate-variant-id', variantId);
    root.setAttribute('data-delivery-eta-pending', 'true');
    root.removeAttribute('data-delivery-eta-ready');
  });
  if (resource.price != null) {
    document.querySelectorAll('.pdp-delivery-returns-card[data-estimate-variant-price]').forEach(function(card) {
      card.setAttribute('data-estimate-variant-price', String(resource.price));
    });
  }
  document.querySelectorAll('[data-delivery-price-badge]').forEach(function(badge) {
    badge.setAttribute('data-delivery-eta-pending', 'true');
    badge.removeAttribute('data-delivery-eta-ready');
  });
  await refreshProductDeliveryEta(resource, updateDisplays);
}

document.addEventListener('variant:update', onVariantUpdate);
document.addEventListener('variant:changed', onVariantUpdate);
document.addEventListener('variant:change', onVariantUpdate);

document.addEventListener('change', function(event) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement) || target.name !== 'quantity') return;
  if (!target.closest('form[data-type="add-to-cart-form"], product-form-component')) return;
  if (!document.querySelector('[data-delivery-estimate-scope="product"]')) return;
  clearDeliveryEtaCache();
  refreshProductDeliveryEta(null, updateDisplays);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
